import { MoreVertIcon } from "@/Components/Icons/Icons";
import ActionCellRenderer from "@/Views/ExportJob/Dashboard/ActionCellRenderer";

const columns = [
  {
    id: "0",
    field: "exportLockStatus",
    headerName: "OL",
    label: "OL",
    align: "center",
    alignItems: "center",
    justifyContent: "center",
    pinned: "left",
    minWidth: 65,
    maxWidth: 65,
    checked: true,
    stopRowClick: true,
  },
  {
    id: "1",
    field: "edocket",
    headerName: "E Docket",
    label: "E Docket",
    align: "center",
    alignItems: "center",
    justifyContent: "center",
    pinned: "left",
    minWidth: 120,
    maxWidth: 120,
    checked: true,
    stopRowClick: true,
  },
  {
    id: "2",
    field: "exporterJobNumber",
    headerName: "Job Number",
    label: "Job Number",
    // // alignItems: "center",
    // // justifyContent: "flex-start",
    minWidth: 230,
    maxWidth: 250,
    pinned: "left",
    checked: true,
  },
  {
    id: "3",
    field: "exportJobDate",
    headerName: "Job Date",
    label: "Job Date",
    // align: "center",
    // alignItems: "center",
    // justifyContent: "flex-start",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    stopRowClick: true,
  },
  {
    id: "4",
    field: "exporterName",
    headerName: "Exporter",
    label: "Exporter",
    // align: "center",
    // alignItems: "center",
    // justifyContent: "flex-start",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
    Notmove: true,

  },
  {
    id: "5",
    field: "exportTransportMode",
    headerName: "Mode",
    label: "Mode",
    // align: "center",
    // alignItems: "center",
    // justifyContent: "flex-start",
    minWidth: 120,
    maxWidth: 250,
    checked: true,
    sort: true,
    Notmove: true,

  },

  {
    id: "6",
    field: "exportCustomHouse",
    headerName: "Custome House",
    label: "Custome House",
    // align: "center",
    // alignItems: "center",
    // justifyContent: "flex-start",
    minWidth: 220,
    maxWidth: 250,
    checked: true,
    sort: true,
    Notmove: true,
  },

  {
    id: "7",
    field: "exportBranchSerialNumber",
    headerName: "Branch NO",
    label: "Branch NO",
    // align: "center",
    // justifyContent: "flex-start",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    Notmove: true,
    sort: true,
  },

  {
    id: "8",
    field: "exportInvoiceBuyerAddress",
    headerName: "Buyer Address",
    label: "Buyer Address",
    // align: "center",
    // alignItems: "center",
    // justifyContent: "flex-start",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
    Notmove: true,

  },
  {
    id: "9",
    field: "exportInvoiceBuyerName",
    headerName: "Buyer Name",
    label: "Buyer Name",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
    Notmove: true,

  },

  {
    id: "10",
    field: "exportConsignee",
    headerName: "Consignee",
    label: "Consignee",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "11",
    field: "exportConsigneeCountry",
    headerName: "Consignee Country",
    label: "Consignee Country",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "12",
    field: "exportConsignmentType",
    headerName: "Consignment Type",
    label: "Consignment Type",
    // align: "center",
    // alignItems: "center",
    minWidth: 200,
    maxWidth: 250,
    checked: true,
    sort: true,
  },

  {
    id: "13",
    field: "shipmentGrossWeight",
    headerName: "Gross Weight",
    label: "Gross Weight",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },
  {
    id: "14",
    field: "shipmentGrossWeightUnit",
    headerName: "Gross Wt U",
    label: "Gross Wt U",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "15",
    field: "exportIECodeNumber",
    headerName: "IE Code No",
    label: "IE Code No",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "16",
    field: "shipmentNetWeight",
    headerName: "Net Weight",
    label: "Net Weight",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "17",
    field: "shipmentTotalNoOfPkgs",
    headerName: "No Of Pkgs",
    label: "No Of Pkgs",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "18",
    field: "exportPendingMilestone",
    headerName: "Pending Milestone",
    label: "Pending Milestone",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "19",
    field: "shipmentTotalNoOfPkgsUnit",
    headerName: "Pkg Unit",
    label: "Pkg Unit",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "20",
    field: "exportSBNumberDate",
    headerName: "S/B Date",
    label: "S/B Date",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },
  {
    id: "21",
    field: "exportSBNumber",
    headerName: "S/B No",
    label: "S/B No",
    // align: "center",
    // alignItems: "center",
    minWidth: 150,
    maxWidth: 200,
    checked: true,
    sort: true,
  },

  {
    id: "actions",
    field: "actions",
    headerName: "Actions",
    label: "Actions",
    align: "center",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 80,
    maxWidth: 100,
    pinned: "right",
    Icon: MoreVertIcon,
    checked: true,
    cellRenderer: ActionCellRenderer,
    stopRowClick: true,
  },
];

export default columns;
